import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import VehicleCardData from './VehicleCardData';
import { enhanceHighlightedAttributes } from '../../../utilities/highlightedAttributes';
import { selectIsListLayout } from '../../../utilities/layout';

const Details = ({
	vehicle,
	incentives,
	accounts,
	isDisplayingEPrice,
	setIsDisplayingEPrice,
	showExpandedPricing,
	setShowExpandedPricing,
	showNewCarBoostPaymentsInDetails
}) => {
	const { accountId } = useSelector((state) => state.widgetInfo);
	const isListLayout = useSelector((state) => selectIsListLayout(state));

	const labels = useLabels();

	const highlightedAttributes = enhanceHighlightedAttributes(
		vehicle,
		accounts,
		isListLayout
	);
	const containerRef = useRef();

	useEffect(() => {
		const tablist = containerRef.current.querySelector('[role=tablist]');
		if (!tablist) {
			return;
		}
		tablist.setAttribute('aria-label', labels.get('VEHICLE_SUMMARY'));
	}, [labels]);

	return (
		<div ref={containerRef} className="h-100 d-flex flex-column">
			<VehicleCardData
				accountId={accountId}
				accountInfo={{ ...accounts[vehicle.accountId] }}
				incentives={incentives}
				vehicle={vehicle}
				highlightedAttributes={highlightedAttributes}
				isDisplayingEPrice={isDisplayingEPrice}
				setIsDisplayingEPrice={setIsDisplayingEPrice}
				showExpandedPricing={showExpandedPricing}
				setShowExpandedPricing={setShowExpandedPricing}
				showNewCarBoostPaymentsInVehicleCardData={
					showNewCarBoostPaymentsInDetails
				}
			/>
		</div>
	);
};

Details.propTypes = {
	vehicle: PropTypes.shape({
		title: PropTypes.arrayOf(PropTypes.string),
		uuid: PropTypes.string,
		link: PropTypes.string,
		accountId: PropTypes.string,
		condition: PropTypes.string,
		callout: PropTypes.arrayOf(PropTypes.shape({})),
		packages: PropTypes.arrayOf(PropTypes.string),
		incentiveIds: PropTypes.arrayOf(PropTypes.string),
		bestIncentiveIds: PropTypes.arrayOf(PropTypes.string),
		inventoryButtons: PropTypes.arrayOf(PropTypes.shape({})),
		images: PropTypes.arrayOf(PropTypes.shape({})),
		isNewCarBoost: PropTypes.bool,
		attributes: PropTypes.arrayOf(PropTypes.shape({})),
		highlightedAttributes: PropTypes.arrayOf(PropTypes.shape({})),
		pricing: PropTypes.shape({}),
		year: PropTypes.number,
		model: PropTypes.string,
		trim: PropTypes.string,
		make: PropTypes.string,
		vin: PropTypes.string,
		fuelType: PropTypes.string,
		spotlightedVehicle: PropTypes.bool
	}).isRequired,
	incentives: PropTypes.shape({}),
	accounts: PropTypes.shape({}),
	isDisplayingEPrice: PropTypes.bool.isRequired,
	setIsDisplayingEPrice: PropTypes.func.isRequired,
	showExpandedPricing: PropTypes.bool.isRequired,
	setShowExpandedPricing: PropTypes.func.isRequired,
	showNewCarBoostPaymentsInDetails: PropTypes.bool
};

Details.defaultProps = {
	incentives: {},
	accounts: {}
};

export default Details;
